<script>
	import Image from '$lib/Components/Layout/Image/Image.svelte';

	let { image = null, children } = $props();
</script>

<!-- eslint-disable better-tailwindcss/no-unknown-classes -->

<div class="full-width parallax">
	{#if image}
		<div class="col-span-full!">
			<Image src={image} class="w-full max-w-full" />
		</div>
	{/if}
	<div>
		{@render children?.()}
	</div>
</div>

<style>
	.parallax {
		position: relative;
		z-index: -999;
		animation: parallax linear;
		animation-timeline: view(-20% -20%);
		margin-top: -10%;
		margin-bottom: -10%;
	}
	@keyframes parallax {
		from {
			transform: translateY(-33%);
		}
		to {
			transform: translateY(var(--translateY, 33%));
		}
	}
</style>
